export const REFER_A_FRIEND_LINK =
  'https://referral.ketch.com/?utm_campaign=Referral%20Program&utm_source=ketch_platform&utm_content=nav_button'
